import React from 'react'
import { Pane, Text } from "evergreen-ui";
import {
  isMixedInterviewRound,
  majorNeedsInterview,
  resolveNoInterviewText,
  useStatusContent,
} from '../../../config/roundContent'

const DetailClassInterviweLevel1 = ({ DataRegister }) => {
    const { content, statusContent } = useStatusContent(DataRegister?.ROB_ID, DataRegister?.REGISTER_STATUS || "1")
    const msgNoInterview = resolveNoInterviewText(content, statusContent)
    const mixed = isMixedInterviewRound(content, DataRegister?.ROB_ID)
    const needsInterview = majorNeedsInterview(
      content,
      DataRegister?.ROB_ID,
      DataRegister?.Major_MAJOR_ID || DataRegister?.Major1_MAJOR_ID
    )

    const roomBlock = (
        <>
            <Pane
                color="#ffffff"
                backgroundColor="#ff0000"
                height="100%"
                paddingY={4}
                paddingX={5}
                fontSize={16}
                fontWeight={700}
                marginTop={10}
                display="flex" alignItems="center" justifyContent="center"
            >
                <Text fontWeight={700} style={{ color: "#ffffff" }}>
                    * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                </Text>
            </Pane>

            <div className="d-flex">
                <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                <div> {DataRegister.Major_MAJOR_CLASSROOM}</div>
            </div>
            <div className="d-flex">
                <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                <div> {DataRegister.Major_MAJOR_CLASSROOM2} </div>
            </div>
            <div className="d-flex">
                <Text fontWeight={600}>
                    &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                    &nbsp;&nbsp; &nbsp;
                </Text>
                <div> {DataRegister.Major_MAJOR_CLASSROOM3} </div>
            </div>
        </>
    )

    if (mixed) {
        return needsInterview
            ? roomBlock
            : (
                <Text color="#fa0000ff" fontWeight={700} style={{ whiteSpace: "pre-line" }}>
                    {msgNoInterview}
                </Text>
            )
    }

    return roomBlock
}

export default DetailClassInterviweLevel1
